// Domain terms the LanguageTool spellchecker should not flag — transfer-pricing
// and entity abbreviations restored from the retired TinyMCE premium dictionary
// (removed under TPX-112, restored under JPD-177). Passed to the editor as
// `languagetool_ignore_list`; the plugin lowercases both sides when matching, so
// a single casing per term is enough. Kept in sync with the canonical list in
// transfer-pricing-ui (src/constants.ts EDITOR_IGNORED_WORDS).
export const EDITOR_IGNORED_WORDS = [
  'Exactera',
  'Comparables',
  'Interquartile',
  'NCP',
  'OM',
  'ROA',
  'CP',
  'BR',
  'GM',
  'CPM',
  'TNMM',
  'CUT',
  'CUP',
  'RSP',
  'PLI',
  'OECD',
  'PS',
  'RPM',
  'SCM',
  'Renderer',
  'CUSP',
  'CSP',
  'GSMM',
  'Licensor',
  'Rentee',
  'LLC',
  'GmbH'
];
